import { render, staticRenderFns } from "./PaymentSlips.vue?vue&type=template&id=181ea8a8&"
import script from "./PaymentSlips.vue?vue&type=script&lang=js&"
export * from "./PaymentSlips.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports